import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IGraphSetData } from 'types/ActionTrackerGraphs'
import remove from 'lodash/remove';
import { getUUID } from 'utils/utils'

interface Props {
  insights: IGraphSetData[]
  showInsightSection: boolean
  table_viewMode: 'view' | 'edit' 
  insights_viewMode: 'view' | 'edit'
  ApiCallController: number
  DataChangeNotifier: string | null
  isDataChanged: boolean
}

const initialState: Props = {
  insights: [],
  table_viewMode: 'view',
  insights_viewMode: 'view',
  showInsightSection: true,
  ApiCallController: 0,
  DataChangeNotifier: null, // used to refetch chart api if action create or update
  isDataChanged: false,
}

const modalStateSlice = createSlice({
  name: 'ActionTrackerInsights',
  initialState,
  reducers: {
    SetATInsights: (state, action: PayloadAction<Props>) => {
      Object.assign(state, action.payload)
    },
    clearATInsights: (state) => {
      Object.assign(state, initialState)
    },
    ATItoggleinsightSection: (state) => {
      state.showInsightSection = !state.showInsightSection
    },
    ATItoggleViewMode: (state, action) => {
      const {key, value} = action.payload
      Object.assign(state, {...state, [key]:value})
      
    },

    ATIresetEdit: (state) => {
      state.showInsightSection = true
      state.table_viewMode = 'view'
      state.insights_viewMode = 'view'
    },

    ATIupdateInsightsGraph: (state, action) => {
      const { rowIndex, columnIndex, key, value } = action.payload
      const updateVal = { [key]: value }
      const oldVal = state.insights[rowIndex].data[columnIndex]
      state.insights[rowIndex].data[columnIndex] = { ...oldVal, ...updateVal }
    },

    ATIrowsColumnDataPositionChange: (state, action) => {
      const { rowIndex, rowData } = action.payload
      state.insights[rowIndex].data = rowData
    },

    ATIDeleteRow: (state, action) => {
      const { rowIndex } = action.payload
      const array = state.insights
      remove(state.insights, (value, index) => index === rowIndex)
      // state.insights = array
    },

    ATIDeleteGraph: (state, action) => {
      const { rowIndex, columnIndex } = action.payload
      const oldVal = state.insights[rowIndex].data[columnIndex]
      state.insights[rowIndex].data[columnIndex] = {
        ...oldVal,
        filters: {},
        graph_type: null,
        sorts: {},
        title: '',
      }
    },

    ATIColumnPositionChange: (state, action) => {
      const { rowIndex, moveRow } = action.payload
      const oldVal = state.insights
      if (moveRow === 'up' && rowIndex > 0) {
        const temp = oldVal[rowIndex - 1]
        oldVal[rowIndex - 1] = oldVal[rowIndex]
        oldVal[rowIndex] = temp
      } else if (moveRow === 'down' && rowIndex < state.insights?.length - 1) {
        const temp = oldVal[rowIndex + 1]
        oldVal[rowIndex + 1] = oldVal[rowIndex]
        oldVal[rowIndex] = temp
      }
    },
    ATIGraphFilterUpdate: (state, action) => {
      state.insights = state.insights?.map((row) => ({
        data: row.data?.map((graph) => ({
          ...graph,
          filters: { ...graph?.filters, ...action.payload },
        })),
        is_visible: row.is_visible ?? true,
      }))
    },
    ATIGraphRowVisible: (state, action) => {
      const { rowIndex, value } = action.payload
      if (value === null) {
        state.insights[rowIndex].is_visible = !state.insights[rowIndex].is_visible
      } else {
        state.insights[rowIndex].is_visible = value
      }
    },
    ATIGrapsRowGraphsUpdate: (state, action) => {
      const { rowIndex, value } = action.payload
      state.insights[rowIndex].data = value
    },
    ATISetApiCallController:(state, action) => {
      const value = action.payload
      if(value === null) {
        state.ApiCallController = 0
      }else{
        state.ApiCallController = (state.ApiCallController ?? 0) + value
      }
    },
    notifyUpdateATdata: (state) => {
      state.DataChangeNotifier = getUUID();
  },
  ATIupdateDataChangeFlag: (state, action) => {
    state.isDataChanged = action.payload ?? false
  },
  },
})

export const {
  SetATInsights,
  ATItoggleinsightSection,
  ATItoggleViewMode,
  ATIupdateInsightsGraph,
  ATIDeleteRow,
  ATIDeleteGraph,
  ATIrowsColumnDataPositionChange,
  ATIColumnPositionChange,
  ATIGraphFilterUpdate,
  ATIGraphRowVisible,
  ATIGrapsRowGraphsUpdate,
  clearATInsights,
  notifyUpdateATdata,
  ATISetApiCallController,
  ATIupdateDataChangeFlag
} = modalStateSlice.actions
export default modalStateSlice.reducer
